// extracted by mini-css-extract-plugin
export default {"instructionsGif":"instructions-by-browser__instructionsGif__pKN5E"};